import React from 'react';
import { TextField } from '@mui/material';

export default function QuantizationField({
  value,
  onChange,
  disabled = false,
}) {
  return (
    <TextField
      label='Quantization'
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
    />
  );
}
